export default __webpack_public_path__ + "static/media/arrowOpen_ico.c1224072.svg";